import { createClient } from '@supabase/supabase-js'
import { env } from '@/config/env'
import type { Database } from '@/types/database.generated'

// Only create Supabase client if not using mock data
export const supabase = env.app.useMockData
  ? null
  : createClient<Database>(env.supabase.url, env.supabase.anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
      },
      db: {
        schema: 'public',
      },
      global: {
        headers: {
          'x-application-name': env.app.name,
        },
      },
    })

// Helper function to handle Supabase errors
export function handleSupabaseError(error: unknown): Error {
  if (error instanceof Error) {
    return error
  }
  return new Error('An unknown error occurred')
}
